<template>
  <div>
    <detail-field class="mt-3">
      <div slot="label">Contact ID:</div>
      <div slot="value">{{ event.contact_id }}</div>
    </detail-field>
    <detail-field class="mt-3" v-if="event.message_id">
      <div slot="label">Message ID:</div>
      <div slot="value">{{ event.message_id }}</div>
    </detail-field>
    <detail-field class="mt-3" v-if="event.error_desc">
      <div slot="label">Error description:</div>
      <div slot="value">{{ event.error_desc }}</div>
    </detail-field>
    <detail-field class="mt-3" v-if="event.payload && event.payload.content">
      <div slot="label">Message type:</div>
      <div slot="value">{{ event.payload.content.type }}</div>
    </detail-field>
    <detail-field class="mt-3" v-if="event.payload && event.payload.content">
      <div slot="label">Message:</div>
      <div slot="value">
        <pre>{{ event.payload.content.payload }}</pre>
      </div>
    </detail-field>
  </div>
</template>

<script>
  import DetailField from '@/components/administration/common/Field'

  export default {
    components: {
      'detail-field': DetailField
    },

    props: {
      event: {
        type: Object,
        required: true
      }
    }
  }
</script>
